import * as React from 'react';

export interface IGridSystemStyles {
    classes: any;
}

export const gridSystemStylesContext = React.createContext<IGridSystemStyles>({ classes: {} });

export const GridSystemStylesProvider = gridSystemStylesContext.Provider;
export const GridSystemStylesConsumer = gridSystemStylesContext.Consumer;

export function selectColumnClassName(styles: IGridSystemStyles, options: { baseClassName?: string; columnSize?: string; offsetLeft?: string; offsetRight?: string; }) {
    const className = options.columnSize ? styles.classes[`column_${options.columnSize}`] || '' : '';
    const leftOffsetClassName = (options.offsetLeft && styles.classes[`columnOffsetLeft_${options.offsetLeft}`]) || '';
    const rightOffsetClassName = (options.offsetRight && styles.classes[`columnOffsetRight_${options.offsetRight}`]) || '';

    return [options.baseClassName || '', styles.classes.column, className, leftOffsetClassName, rightOffsetClassName].join(' ');
}

export function selectColumnRules(styles: IGridSystemStyles, options: { columnSize?: string; offsetLeft?: string; offsetRight?: string; }) {
    const columnRules = options.columnSize ? styles.classes[`column_${options.columnSize}`] : [];
    const leftOffsetRules = (options.offsetLeft && styles.classes[`columnOffsetLeft_${options.offsetLeft}`]) || [];
    const rightOffsetClassName = (options.offsetRight && styles.classes[`columnOffsetRight_${options.offsetRight}`]) || [];

    return styles.classes.column_base.concat(columnRules.concat(leftOffsetRules).concat(rightOffsetClassName));
}
